import {
  InfiniteScrollCarousel,
  InfiniteScrollCarouselHandle,
} from "@/components/ui/InfiniteScrollCarousel";
import { useRef } from "react";
import { ExpertItems } from "./ExpertItems";
import { useExpertSelection } from "./ExpertSelectionContext";

export const GroupExpertCarousel = () => {
  const { groupExperts, selectedExpertUuids, groupUuid, selectExperts } =
    useExpertSelection();

  const carouselRef = useRef<InfiniteScrollCarouselHandle>(null);

  if (groupExperts.length === 0) return null;

  const handleExpertClick = (
    event:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | React.MouseEvent<HTMLLIElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    carousel.setKeepPaused(true);
    carousel.pause();

    const container = carousel.getScrollContainer();
    if (!container) return;

    const target = event.currentTarget;
    const targetRect = target.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const targetCenter =
      targetRect.left + targetRect.width / 2 - containerRect.left;

    const containerCenter = container.offsetWidth / 2;
    const distanceToCenter = targetCenter - containerCenter;
    const targetPosition = carousel.getTranslateX() - distanceToCenter;

    carousel.animateToPosition(targetPosition);
  };

  const handleExpertSelection = (selectedExpertUuids: Set<string>) => {
    selectExperts(selectedExpertUuids);
  };

  const expertItems = (
    <ul className="flex flex-row flex-nowrap gap-2 px-1 py-0.5">
      <ExpertItems
        groupUuid={groupUuid}
        experts={groupExperts}
        max={1}
        disableUnselect
        selectedExpertUuids={selectedExpertUuids}
        previousSelectedExpertUuids={null}
        onExpertElementClick={handleExpertClick}
        onExpertSelection={handleExpertSelection}
        variant="cards"
      />
    </ul>
  );

  return (
    <div className="flex flex-col gap-4">
      <InfiniteScrollCarousel ref={carouselRef} resetKey={groupExperts}>
        {expertItems}
      </InfiniteScrollCarousel>
    </div>
  );
};
